import { REF_TYPES } from "./constants.js";
export function isCommitOidForProfile(v, profile) {
    return typeof v === "string" && OID_PATTERN_BY_PROFILE[profile].test(v);
}
const OID_PATTERN_BY_PROFILE = {
    sha1: /^[0-9a-f]{40}$/,
    sha256: /^[0-9a-f]{64}$/,
};
export function isCommitOid(v) {
    return isCommitOidForProfile(v, "sha1") || isCommitOidForProfile(v, "sha256");
}
export function isRefType(value) {
    return typeof value === "string" && REF_TYPES.includes(value);
}
//# sourceMappingURL=guards.js.map